import { Box, Typography } from "@mui/material";

const HeaderLabelTitle = ({ ...props }) => {
  const sx = props.sx;
  const color = props.color || "primary";
  const suffix = props.suffix == undefined ? ":" : props.suffix;
  const required = props.required || false;
  const align = props.align || "right";

  return (
    <Box
      component="span"
      color={color}
      sx={{
        ...sx,
        textAlign: align || "right",
        display: "flex",
        justifyContent: align === "right" ? "flex-end" : "flex-start",
        alignItems: "center",
        height: "100%",
        paddingRight: "8px",
      }}
      className="hm-text-title"
      dangerouslySetInnerHTML={{
        // __html: props.title ? props.title + suffix : "",
        __html: props.title
          ? props.title +
            suffix +
            (props.required ? '<span class="requiredLabel">*</span>' : "")
          : "",
      }}
    />
  );
};

export default HeaderLabelTitle;
